//import logo from './logo.svg';
import React, { useEffect } from "react";
import "./index.css";
import Signin from "./main/Components/Signin/Signin";
import { UserModel } from "./main/Components/Dashboard/Managers/dataStructures";
import DashboardMain from "./main/Components/Dashboard/DashboardMain";
import {
  getCurrentUser,
  isUserLoggedIn,
  saveProfileData,
} from "./main/Components/Dashboard/Managers/profileManager";
import ForgotPassword from "./main/Components/Signin/ForgotPassword";
//import { BrowserRouter, Route, Routes } from "react-router-dom";

export default function App() {
  const [currentUser, setCurrentUser] = React.useState<UserModel | null>();
  const isLoggedIn: boolean =
    currentUser !== null && currentUser !== undefined ? true : false;
  const [isForgotPassword, setIsForgotPassword] =
    React.useState<boolean>(false);

  useEffect(() => {
    if (isUserLoggedIn() === true && currentUser == null) {
      setCurrentUser(getCurrentUser());
    }
    //cleanup call
    //return ()=>{console.log}
  }, [currentUser]);

  function onSignInHandler(auth_token: string, currentuser: UserModel) {
    saveProfileData(auth_token, currentuser);
    setCurrentUser(currentuser);
    setIsForgotPassword(false);
    window.location.reload();
  }

  function onForgotPassword() {
    //console.log("forgot password");
    setIsForgotPassword(true);
  }

  function closeForgotPassword() {
    setIsForgotPassword(false);
  }

  return (
    <div className="App">
      {isLoggedIn === true ? (
        <DashboardMain />
      ) : // <LoadRoutes path={"/index.html"} onSignInHandler={onSignInHandler} />
      isForgotPassword === true ? (
        <ForgotPassword close={closeForgotPassword} />
      ) : (
        <Signin
          callback={onSignInHandler}
          onForgotPasswordHandler={onForgotPassword}
        />
      )}
    </div>
  );
}

// function LoadRoutes(props: {
//   path?: string;
//   onSignInHandler: (auth_token: string, currentuser: UserModel) => void;
//   onForgot: () => void;
// }) {
//   return (
//     <BrowserRouter>
//       <Routes>
//         <Route
//           path="/"
//           element={
//             <Signin
//               callback={props.onSignInHandler}
//               onForgotPasswordHandler={props.onForgot}
//             />
//           }
//         />
//         <Route
//           path="*"
//           element={
//             <Signin
//               callback={props.onSignInHandler}
//               onForgotPasswordHandler={props.onForgot}
//             />
//           }
//         />
//         <Route
//           path="/index.html"
//           element={
//             <Signin
//               callback={props.onSignInHandler}
//               onForgotPasswordHandler={props.onForgot}
//             />
//           }
//         />
//         <Route
//           path="/signin"
//           element={
//             <Signin
//               callback={props.onSignInHandler}
//               onForgotPasswordHandler={props.onForgot}
//             />
//           }
//         />
//         <Route
//           path="/#signin"
//           element={
//             <Signin
//               callback={props.onSignInHandler}
//               onForgotPasswordHandler={props.onForgot}
//             />
//           }
//         />
//         <Route
//           path="/#5"
//           element={
//             <Signin
//               callback={props.onSignInHandler}
//               onForgotPasswordHandler={props.onForgot}
//             />
//           }
//         />
//         <Route path="/forgot-password" element={<ForgotPassword />} />
//         <Route path="dashboard" element={<DashboardMain />} />
//       </Routes>
//     </BrowserRouter>
//   );
// }
